import React from "react";
import { NavLink } from "react-router-dom";
import Image from "../../../partials/Image";

const SingleStaffGrid = ({ items = [], handleProfile }) => {
    return (
        <div className="row">
            {items.map(staff => (
                <div key={staff.id} className="col-md-6 col-lg-3 col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="doctor-profile">
                                <center>
                                    <Image src={staff.image} alt={staff.surname} height={100} width={100} />
                                </center>

                                <div className="profile-usertitle">
                                    <div className="profile-usertitle-name">
                                        {staff.first_name} {staff.middle_name} {staff.surname}{" "}
                                    </div>
                                    <div className="profile-usertitle-job">
                                        Designation:
                                        <strong className="text-success"> {staff.designation.name}</strong> {staff.admin && <span className="badge badge-success">Admin</span>}
                                    </div>
                                </div>
                                <p>
                                    <i className="fa fa-phone"></i>
                                    <a href={`tel:${staff.mobile}`}>{staff.mobile}</a>
                                </p>
                                <p>
                                    <h5>NIN: {staff.nin || "None"}</h5>
                                </p>
                                <p>
                                    <i className="fa fa-envelope"></i>
                                    <a href={`mailto:${staff.email}`}> {staff.email}</a>
                                </p>
                            </div>
                        </div>
                        <card className="card-footer text-center mb-3">
                            <NavLink
                                to={{
                                    pathname: "/home/staffing/profile",
                                    search: `?ref=${staff.id}`
                                }}
                                onClick={() => handleProfile}
                                className="btn btn-tbl-edit btn-xs btn-success mx-2"
                                title="View Profile"
                            >
                                <i className="fa fa-user"></i>
                            </NavLink>
                            {/* Assign patients to staff action button*/}
                            <NavLink
                                to={{
                                    pathname: "/home/staffing/assign-patient",
                                    state: { activeStaff: staff }
                                }}
                                className="btn btn-tbl-edit btn-xs btn-success mx-2"
                                title="Assign Patient"
                            >
                                <i className="fa fa-book"></i>
                            </NavLink>
                            {/* Edit staff action button */}
                            <NavLink
                                to={{
                                    pathname: "/home/staffing/edit",
                                    state: { activeStaff: staff }
                                }}
                                className="btn btn-tbl-edit btn-xs btn-success mx-2"
                                title="Edit"
                            >
                                <i className="fa fa-pencil"></i>
                            </NavLink>
                        </card>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SingleStaffGrid;
